import { LiloDrugSearchResponse } from '@lib/core/models/protocol.interface';

import { PharmacologicalItemMetaData, ResponseMorionItem } from '../models/prescription.interface';

export function getMedicationUniqueForms(metadata: PharmacologicalItemMetaData): string[] {
  let forms: string[] = [];
  if (metadata.morion_items) {
    const morionItems: ResponseMorionItem[] = JSON.parse(metadata.morion_items);
    forms = morionItems.map(item => item.FormUa);
  } else if (metadata.trademarks) {
    const trademarks: LiloDrugSearchResponse[] = JSON.parse(metadata.trademarks);
    forms = trademarks.map(item => item.formUa);
  }
  return [...new Set(forms)].filter(Boolean);
}

export function getMedicationInn(metadata: PharmacologicalItemMetaData): string {
  return metadata.inn?.toUpperCase() ?? '';
}

export function getMedicationFullName(metadata: PharmacologicalItemMetaData): string {
  const inn = getMedicationInn(metadata);
  const uniqueForms = getMedicationUniqueForms(metadata);
  return uniqueForms.length ? `${inn} ${uniqueForms.join(', ')}` : inn;
}
